import { HttpClient } from "@angular/common/http";
import { BaseService } from "../../../shared/Services/BaseService";
import { authenticationService } from "../../../shared/Services/authenticationService";
import { environment } from "../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IUserInfo } from "../Models/UserProfileModel";

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
    private image = new BehaviorSubject<string>(''); // الصورة الحالية
    currentImage: Observable<string> = this.image.asObservable(); 
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    super(http, authenticationSerives, environment.apiUrl + 'Users');    
  }
    updateImage(newImage: string) {
    this.image.next(newImage);
  }

    getUser(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Users'+ '/info',{
      headers: this.getAuthorizationHeader(),
    });
  }

      getUserPages(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Users'+ '/userPages',{
      headers: this.getAuthorizationHeader(),
    });
  }

  updateUserImg(data: IUserInfo): Observable<any> {
    return this.http.put(environment.apiUrl + 'Users' + '/' + data.id, data);
  }

}
